module.exports = __webpack_public_path__ + "static/media/Oopz.8dd4e1db.png";